// Утилиты отображения для игры «Ставки».

export function plMatch(n) {
    const num = n || 0;
    const mod10 = num % 10;
    const mod100 = num % 100;
    let word = 'матчей';
    if (mod10 === 1 && mod100 !== 11) word = 'матч';
    else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) word = 'матча';
    return `${num} ${word}`;
}

export function plBets(n) {
    const num = n || 0;
    const mod10 = num % 10;
    const mod100 = num % 100;
    let word = 'ставок';
    if (mod10 === 1 && mod100 !== 11) word = 'ставка';
    else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) word = 'ставки';
    return `${num} ${word}`;
}

export function formatDt(dateStr) {
    const date = new Date(dateStr);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const mi = String(date.getMinutes()).padStart(2, '0');
    return `${dd}.${mm}, ${hh}:${mi}`;
}

export function betsLabel(bets, finished) {
    const active = bets.filter(b => !b.refunded);
    const refunded = bets.length - active.length;
    const total = active.reduce((sum, b) => sum + (b.amount || 0), 0);
    const base = `Ставки: ${active.length} шт. на ${total} монет`;
    let tail;
    if (finished) {
        const won = active.filter(b => b.isWin === true).length;
        const lost = active.filter(b => b.isWin === false).length;
        tail = `выигрыш: ${won}, проигрыш: ${lost}`;
    } else {
        tail = `в игре: ${active.length}`;
    }
    if (refunded > 0) tail += `, возвращено: ${refunded}`;
    return `${base} (${tail})`;
}

export function sortScores(odds) {
    return Object.entries(odds).sort(([a], [b]) => {
        const [a1, a2] = a.split(':').map(Number);
        const [b1, b2] = b.split(':').map(Number);
        return a1 - b1 || a2 - b2;
    });
}

export function placeClass(place) {
    if (place === 1) return 'p1';
    if (place === 2) return 'p2';
    if (place === 3) return 'p3';
    return 'po';
}
